<template>
  <div class="coininfo">
    <p class="coininfo-name">{{ letter.coinTypeName }} {{ getCoinsName }}</p>
    <p class="coininfo-balance">
      <span class="coininfo-balance-pre">{{ letter.curBalance }}: </span>
      <span class="coininfo-balance-center">{{
        isUidLogin ? '***' : curCoinAmount
      }}</span>
      <span class="coininfo-balance-after">{{ curCoinCurrency }}</span>
    </p>
    <a
      href="javascript:;"
      class="coininfo-pay"
      @click="visibleCoinsAgreePopupHandle(true)"
      >{{ letter.payIntro }}</a
    >
    <coins-agree-popup
      v-bind:visible.sync="visibleCoinsAgreePopup"
    ></coins-agree-popup>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getLocaLclStor } from '@store/officialStore/storager';
import CoinsAgreePopup from '@components/officialStore/coins/CoinsAgreePopup.vue';
import coinsAgree from '@mixins/officialStore/coinsAgree';

export default {
  name: 'CoinsInfoCard',
  mixins: [coinsAgree],
  data() {
    return {
      locations: getLocaLclStor()
    };
  },
  computed: {
    ...mapState({
      isUidLogin: state => state.login.isUidLogin,
      gameId: state => state.gameId,
      curCoinAmount: state => state.coins.curCoinAmount,
      curCoinCurrency: state => state.coins.curCoinCurrency,
      letter: state => state.letter
    }),
    ...mapGetters(['getCoinsName'])
  },
  components: {
    CoinsAgreePopup
  }
};
</script>

<style lang="scss" scoped>
.coininfo {
  overflow: hidden;
  margin: auto;
  text-align: center;
  font-weight: bold;
  color: #ffffff;
  @psetbg ("coininfo-bg.png");
  &-name {
    position: relative;
    display: inline-block;
    margin: 64px auto 32px;
    font-size: 30px;
  }
  &-balance {
    margin-bottom: 50px;
    &-pre {
      font-size: 36px;
    }
    &-center {
      font-size: 56px;
      color: #c1a15e;
    }
    &-after {
      margin-left: 16px;
      font-size: 28px;
    }
  }
  &-pay {
    display: block;
    margin: 0 auto 16px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    font-size: 34px;
    line-height: 74px;
    color: #ffffff;
    @psetbg ("coininfo-pay-active.png");
  }
}
</style>
